// A path belongs to the customer QR-scan flow (spin the wheel) rather than
// the general site. Used to decide when to hide B2B chrome (nav, role
// picker) from a customer who's just trying to spin the wheel.
export function isWheelPath(pathname) {
  return !!pathname && (pathname.startsWith('/spin/') || pathname.startsWith('/wheel/'));
}
